var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "使用的激活码", prop: "activation_code" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择激活码",
                    disabled: _vm.formData.id != ""
                  },
                  model: {
                    value: _vm.formData.activation_code,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "activation_code", $$v)
                    },
                    expression: "formData.activation_code"
                  }
                },
                _vm._l(_vm.activationList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.code, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "比赛分数", prop: "score" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.formData.score,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "score", $$v)
                  },
                  expression: "formData.score"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "比赛时长(分钟)", prop: "duration" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "1:00.00" },
                model: {
                  value: _vm.formData.duration,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "duration", $$v)
                  },
                  expression: "formData.duration"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "学生", prop: "student_id" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择学生",
                    disabled: _vm.formData.id != ""
                  },
                  model: {
                    value: _vm.formData.student_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "student_id", $$v)
                    },
                    expression: "formData.student_id"
                  }
                },
                _vm._l(_vm.studentList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.student_name + "-" + item.id_card,
                      value: item.student_id
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }